import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_big-arrow-right",
  "use": "icon_big-arrow-right-usage",
  "viewBox": "0 0 88 84",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 88 84\" fill=\"none\" id=\"icon_big-arrow-right\"><path d=\"M4.37114e-08 41.5L-0.5 41.5L-0.5 42.5L-4.37114e-08 42.5L4.37114e-08 41.5ZM-4.37114e-08 42.5L71.767 42.5L71.767 41.5L4.37114e-08 41.5L-4.37114e-08 42.5Z\" fill=\"currentColor\" /><path d=\"M46.0781 16.3105L71.7674 41.9999L46.0781 67.6892\" stroke=\"currentColor\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol